import {
    setStepsToCopy,
    setEasyPatternToCopy,
    setTrackPresetSaving,
    setTrackToConvert,
    setIsTranscribing
} from 'actions/index.js';

export const makePlanar = (track) => {
    track.midiEffects.makePlanar();
};

export const copyAllSteps = (track) => {
    let currentPattern = track.currentPattern;
    let allSteps = track.getEasyPattern().getAllSteps();
    track.sequencerEngine.dispatch(setStepsToCopy(allSteps));
    track.sequencerEngine.dispatch(setEasyPatternToCopy(track.getEasyPattern()));
};

export const makeInstrumentRack = (track) => {
    track.sequencerEngine.dispatch(
        setTrackToConvert(track));
};

export const extractStems = (track) => {
    track.extractStems();
};

export const makeEffectRack = (track) => {
    track.effectsChain.convertToRack();
};

export const makeMidiEffectRack = (track) => {
    track.midiEffects.convertToRack();
};

export const savePreset  = (track) => {
    track.sequencerEngine.dispatch(
        setTrackPresetSaving(track));
};

export const deleteLocks = (track) => {
    track.deletePatternLocks();
};

export const deleteAutomations  = (track) => {
    track.deleteAutomations();
};

export const transcribeTrack  = (track) => {
    track.sequencerEngine.dispatch(setIsTranscribing(true));
    setTimeout(() => {
        track.sequencerEngine.transcribeIntoMidi(track)
            .then(
                () => {
                    track.sequencerEngine.dispatch(setIsTranscribing(false));
                });
    }, 200);
};

export const freezePatterns= (track) => {
    track.freezeAllPatterns();
};
